import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import clsx from 'clsx'
import gsap from 'gsap'
import { FC, useEffect, useRef, useState } from 'react'
import useMeasure from 'react-use-measure'
import s from './LineClamp.module.scss'

export type LineClampProps = {
  text?: string
  readMoreText?: string
  textClassname?: string
}

const LineClamp: FC<LineClampProps> = ({
  text,
  textClassname,
  readMoreText,
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false)
  const [ref, { height: viewHeight }] = useMeasure()
  const readMoreContainer = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (!readMoreContainer.current) return
    gsap.to(readMoreContainer.current, {
      height: isExpanded ? viewHeight : 0,
      opacity: isExpanded ? 1 : 0,
      duration: 0.2,
    })
  }, [readMoreContainer.current, isExpanded])
  return (
    <div className={clsx(s.root, textClassname)}>
      <span>
        <TrustedHtml html={text} />
      </span>
      <div ref={readMoreContainer} className="overflow-hidden">
        <div ref={ref}>
          <TrustedHtml html={readMoreText} />
        </div>
      </div>
      {readMoreText && (
        <button
          type="button"
          className={clsx(s.btn)}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            setIsExpanded(!isExpanded)
          }}
        >
          {isExpanded ? (
            <span>Read less</span>
          ) : (
            <>
              ... <span>Read more</span>
            </>
          )}
        </button>
      )}
    </div>
  )
}

export default LineClamp
